if (!customElements.get('collection-view')) {
  class CollectionView extends HTMLElement {
    constructor() {
      super();

      this.desktopMedia = window.matchMedia('(min-width: 990px)');
      this.handleClick = this.handleClick.bind(this);
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.addEventListener('click', this.handleClick);

      if (this.desktopMedia.addEventListener) {
        this.desktopMedia.removeEventListener('change', this.handleBreakpointChange);
        this.desktopMedia.addEventListener('change', this.handleBreakpointChange);
      } else {
        this.desktopMedia.removeListener(this.handleBreakpointChange);
        this.desktopMedia.addListener(this.handleBreakpointChange);
      }

      this.applyPreferencesToGrid();
      this.updateButtonStates();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);

      if (this.desktopMedia.addEventListener) {
        this.desktopMedia.removeEventListener('change', this.handleBreakpointChange);
      } else {
        this.desktopMedia.removeListener(this.handleBreakpointChange);
      }
    }

    getStorageKey(mode) {
      return `las-olas-grid-columns-${mode}`;
    }

    getButtons(mode) {
      return Array.from(this.querySelectorAll(`.js-btn[data-view-mode="${mode}"]`));
    }

    getAllowedColumns(mode) {
      return this.getButtons(mode).map(button => button.dataset.cols);
    }

    getDefaultColumns(mode) {
      return mode === 'desktop'
        ? this.dataset.desktopDefault
        : this.dataset.mobileDefault;
    }

    getStoredColumns(mode) {
      if (Shopify.designMode) return '';

      try {
        return localStorage.getItem(this.getStorageKey(mode)) || '';
      } catch (error) {
        return '';
      }
    }

    getActiveColumns(mode) {
      const allowedColumns = this.getAllowedColumns(mode);
      const storedColumns = this.getStoredColumns(mode);
      const defaultColumns = this.getDefaultColumns(mode);

      if (allowedColumns.includes(storedColumns)) return storedColumns;
      if (allowedColumns.includes(defaultColumns)) return defaultColumns;
      if (allowedColumns.length) return allowedColumns[allowedColumns.length - 1];

      return defaultColumns || (mode === 'desktop' ? '5' : '2');
    }

    storeColumns(mode, columns) {
      if (Shopify.designMode) return;

      try {
        localStorage.setItem(this.getStorageKey(mode), columns);
      } catch (error) {
        // The grid still updates when browser storage is unavailable.
      }
    }

    applyPreferencesToGrid(productGrid = document.querySelector('#product-grid')) {
      if (!productGrid) return;

      productGrid.dataset.cols = this.getActiveColumns('desktop');
      productGrid.dataset.mobileCols = this.getActiveColumns('mobile');
    }

    updateButtonStates() {
      ['desktop', 'mobile'].forEach(mode => {
        const activeColumns = this.getActiveColumns(mode);

        this.getButtons(mode).forEach(button => {
          const isActive = button.dataset.cols === activeColumns;
          button.disabled = isActive;
          button.setAttribute('aria-pressed', String(isActive));
        });
      });
    }

    handleClick(event) {
      const button = event.target.closest('.js-btn[data-view-mode]');
      if (!button || !this.contains(button)) return;

      const mode = button.dataset.viewMode;
      const columns = button.dataset.cols;

      this.storeColumns(mode, columns);

      const productGrid = document.querySelector('#product-grid');
      if (productGrid) {
        if (mode === 'desktop') {
          productGrid.dataset.cols = columns;
        } else {
          productGrid.dataset.mobileCols = columns;
        }
      }

      this.updateButtonStates();
      this.updateGridItems();

      if (mode === 'desktop') {
        document.querySelector('catalog-pagination')?.onGridChange?.(columns);
      }
    }

    handleBreakpointChange() {
      this.applyPreferencesToGrid();
      this.updateButtonStates();
      this.updateGridItems();
    }

    updateGridItems() {
      const collectionLoadMore = document.querySelector('collection-load-more');
      if (!collectionLoadMore) return;

      collectionLoadMore.setGridColsNumber?.();
      collectionLoadMore.toggleProductsVisibility();
    }
  }

  customElements.define('collection-view', CollectionView);
}
